(ns ui.components.layout.footer
  (:require [ui.util :as uu]))

(defn left-align
  [& children]
  (into [:div
         {:class "flex flex-row gap-2 justify-start"}]
        children))

(defn right-align
  [& children]
  (into [:div
         {:class "flex-1 flex flex-row gap-2 justify-end"}]
        children))

(defn footer
  [& children]
  (into [:div
         {:class "flex-0 flex flex-row gap-1"}]
        children))

(defn center-align
  [{:keys [class]} & children]
  (into [:div
         {:class (uu/cm "flex-1 flex flex-row gap-2 justify-center items-center" class)}]
        children))

(defn footer-3col
  [{:keys [class start-class center-class end-class]} start center end]
  [:div {:class (uu/cm "grid grid-cols-3 items-center gap-3" class)}
   [:div {:class (uu/cm "justify-self-start" start-class)} start]
   [:div {:class (uu/cm "justify-self-center" center-class)} center]
   [:div {:class (uu/cm "justify-self-end" end-class)} end]])
